import { mergeWith, isArray } from 'lodash'

function customizer(objValue, srcValue) {
  if (isArray(objValue)) {
    return objValue = srcValue
  }
}

async function createConfig() {
  try {
    let defaultConfig = await import(`./config.default.js`)
    let projectConfig = await import(`./config.${process.env.VUE_APP_CONFIG}.js`)
    return mergeWith({}, defaultConfig.default, projectConfig.default, customizer)
  } catch (e) {
    console.error(`Failed to load styles: ${process.env.VUE_APP_CONFIG}`, e)
    return {}
  }
}

const config = async() => await createConfig()
export default config
